<template>
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        exact: true,
        to: { name: 'home' }
      },
      {
        text: nombreCategoria,
        exact: true,
        to: { name: 'category', params: { id: categoriaId } }
      }
    ]"
  >
    <v-container class="px-0">
      <v-row justify="center">
        <v-col cols="12">
          <v-card>
            <v-container>
              <v-row justify="center">
                <v-col cols="12" ref="videoParent">
                  <iframe
                    v-if="!loadingVideo"
                    :src="'https://player.vimeo.com/video/' + videoData.url"
                    :width="videoWidth"
                    :height="videoHeight"
                    frameborder="0"
                    allow="autoplay; fullscreen"
                  />
                  <div v-else>
                    <v-row justify="center" align="center" :style="'height: ' + videoHeight + 'px'">
                      <v-progress-circular size="100" indeterminate color="viralYellow" />
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-row justify="start">
                    <v-col cols="12">
                      <span class="text-h6">
                        {{ videoData.nombre }}
                      </span>
                    </v-col>
                    <v-col>
                      <span class="text-subtitle-1">
                        {{ videoData.descripcion }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-container>
              <v-row no-gutters justify="start">
                <!-- eslint-disable-next-line -->
                <span class="text-h6 viralYellow--text">Vídeos relacionados</span>
              </v-row>
              <v-row>
                <v-col v-for="(video, i) in videosRelacionados" :key="video.id" cols="12" sm="6" lg="4">
                  <v-card
                    color="primary-darken-1"
                    @click="clickVideo(video.id)"
                    class="pointer"
                    style="border-radius: 5px"
                  >
                    <v-row no-gutters>
                      <v-col cols="12" :ref="'videoImg-' + i">
                        <v-img
                          :src="video.src"
                          style="border-top-left-radius: 5px;border-top-right-radius: 5px"
                          :width="videoRelacionadoWidth"
                          :height="videoRelacionadoHeight"
                        />
                      </v-col>
                      <v-col cols="12" class="pt-2 pb-3 px-2" style="min-height: 66px">
                        <span class="subtitle-2">
                          {{ video.nombre }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'videoPage',
  props: {
    videoId: {
      required: true
    },
    categoriaId: {
      required: true
    }
  },
  data() {
    return {
      videoWidth: 0,
      videoRelacionadoWidth: 0,
      loadingVideo: true
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize)
    this.videoWidth = this.$refs.videoParent.clientWidth - 24
    this.videoRelacionadoWidth = this.$refs['videoImg-0'][0].clientWidth
    if (this.loadingData) {
      while (this.loadingData) {
        await this.$nextTick()
      }
    } else {
      await this.waitMiliseconds(500)
    }
    this.loadingVideo = false
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    ...mapGetters({
      getAllVideos: 'viralmobile/getAllVideos',
      getVideoById: 'viralmobile/getVideoById',
      getCategoriaById: 'viralmobile/getCategoriaById',
      loadingData: 'viralmobile/getLoading'
    }),
    videosRelacionados() {
      if (this.loadingData) return []
      let retorno = this.getAllVideos
        .filter(x => x.categoriaId == this.categoriaId && x.id != this.videoId)
        .map(x => {
          return {
            ...x,
            src: require('@/assets/images/videos/' + x.imagen)
          }
        })
        .sort(() => 0.5 - Math.random())
      return retorno.slice(0, 6)
    },
    nombreCategoria() {
      if (this.loadingData) return this.categoriaId
      let cat = this.getCategoriaById(this.categoriaId)
      return cat ? cat.nombre.toUpperCase() : this.categoriaId
    },
    videoData() {
      return this.getVideoById(this.videoId)
    },
    videoHeight() {
      return this.videoWidth / 1.7778
    },
    videoRelacionadoHeight() {
      return this.videoRelacionadoWidth / 1.7778
    }
  },
  methods: {
    onResize() {
      this.videoWidth = this.$refs.videoParent.clientWidth - 24
      this.videoRelacionadoWidth = this.$refs['videoImg-0'][0].clientWidth
    },
    async clickVideo(id) {
      if (id != this.categoriaId) {
        this.loadingVideo = true
        this.$router.push({
          name: 'video',
          params: { categoriaId: this.categoriaId, videoId: id }
        })
        window.scrollTo(0, 0)
        await this.waitMiliseconds(500)
        this.loadingVideo = false
      }
    },
    waitMiliseconds(ms) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    }
  }
}
</script>

<style lang="sass" scoped>

.v-card--link:before
  border-radius: 5px
</style>
